import React, { Component } from "react";
import {FaYoutube ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/contentlabofficial/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://instagram.com/contentlab.mn?igshid=NWRhNmQxMjQ=/'},
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UCxIGYb1IQkB67g-H7pnXZ2w/'},
]

class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left">
                                    <div className="inner">
                                        <span>ТА БЭЛЭН ҮҮ</span>
                                        <h2>ХАМТАРЧ АЖИЛЛАЦГААЯ</h2>
                                        <a className="rn-button-style--2" href="/contact">
                                            <span>Холбоо барих</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link">
                                                <h4>Холбоосууд</h4>
                                                <ul className="ft-link">
                                                    <li><a href="/job">Бүтээлүүд</a></li>
                                                    <li><a href="/about">БИД ХЭН БЭ</a></li>
                                                    <li><a href="/contact">Холбоо барих</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4>Холбогдох</h4>
                                                <ul className="ft-link">
                                                    <li><a href="mailto:admin@example.com">admin@example.com</a></li>
                                                    <li><a href="mailto:hr@example.com">hr@example.com</a></li>
                                                </ul>

                                                <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                                </div> 
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>© 2022 Бүх эрхийг хуулиар хамгаалсан. ВЭБ САЙТ БҮТЭЭСЭН TEQSTREAM LLC 75059955</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;